import { AnyAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ChatLayoutOption, ChatTemplate, ClassId } from '~types'

import React from 'react'

export type ViewType = 'method' | 'details' | 'layout' | 'folder'
export type Source = 'empty' | 'community' | 'school'

export interface State {
  view: ViewType
  source?: Source
  loading: boolean
  name: string
  class: ClassId
  grade: string
  layout?: { rows: number; columns: number }
  template?: ChatTemplate
  showFolderSelection: boolean
  selected?: ClassId
  filterTypeChatta: boolean
  filterTypeCommunity: boolean
  dismissTo?: string
}

export const initialState: State = {
  view: 'method',
  loading: false,
  name: '',
  class: {
    id: '',
    name: '',
  },
  grade: '',
  showFolderSelection: false,
  filterTypeChatta: true,
  filterTypeCommunity: true,
}

const newChatSlice = createSlice({
  name: 'newchat',
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        class: state.class,
        showFolderSelection: state.showFolderSelection,
        dismissTo: !state.showFolderSelection ? `/folders/${state.class.id}` : `/`,
      }
    },
    setView: (state, action: PayloadAction<ViewType>) => {
      state.view = action.payload
    },
    setSource: (state, action: PayloadAction<Source>) => {
      state.source = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload
    },
    setLayout: (state, action: PayloadAction<ChatLayoutOption>) => {
      state.layout = {
        rows: action.payload.rows,
        columns: action.payload.columns,
      }
    },
    setTemplate: (state, action: PayloadAction<ChatTemplate | undefined>) => {
      state.name = action.payload?.name ?? ''
      state.template = action.payload
    },
    setClassId: (state, action: PayloadAction<Partial<ClassId>>) => {
      if (action.payload?.id) {
        const id = {
          id: action.payload?.id ?? '',
          name: action.payload?.name ?? '',
        }
        state.class = id
        state.selected = id
      }
    },
    setSelectedClassId: (state, action: PayloadAction<Partial<ClassId>>) => {
      if (action.payload?.id) {
        state.selected = {
          id: action.payload?.id ?? '',
          name: action.payload?.name ?? '',
        }
      }
    },
    setShowFolderSelection: (state, action: PayloadAction<boolean>) => {
      state.showFolderSelection = action.payload
    },
    toggleFilterTypeChatta: (state) => {
      state.filterTypeChatta = !state.filterTypeChatta
    },
    toggleFilterTypeCommunity: (state) => {
      state.filterTypeCommunity = !state.filterTypeCommunity
    },
    setDismissTo: (state, action: PayloadAction<string | undefined>) => {
      state.dismissTo = action.payload
    },
  },
})
export const reducer = newChatSlice.reducer
export const actions = newChatSlice.actions
export const NewChatContext = React.createContext<[State, React.Dispatch<AnyAction>]>([
  initialState,
  () => {},
])
export const useNewChatContext = (): [State, React.Dispatch<AnyAction>] =>
  React.useContext(NewChatContext)
